// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"7678d1af","239":"2a4be29a","411":"27c74955","732":"3f6cadd0","977":"be78e8d7"}[chunkId] + ".chunk.js";
};